export default {
      id: "twitter-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/iconaf3563da19c86b00e5da1e83cc285294.svg#twitter",
      toString: function () {
        return this.url;
      }
    }